import { createInstance, type i18n as I18nInstance } from 'i18next';

import enUS from '../../public/locales/en-US/translation.json';

const mockQuotientI18N: I18nInstance = createInstance();

mockQuotientI18N.init({
  // hard coding tests to just english for now
  lng: 'en-US',
  fallbackLng: 'en-US',
  resources: {
    'en-US': {
      translation: enUS,
    },
    en: {
      translation: enUS,
    },
  },
});

export default mockQuotientI18N;
